import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type SocketHealthState = {
  lastPingTime: number | null
  pingLatency: number
  isPingTimedOut: boolean
}

const initialState: SocketHealthState = {
  lastPingTime: null,
  pingLatency: 0,
  isPingTimedOut: false
}

const socketHealthSlice = createSlice({
  name: 'socketHealth',
  initialState,
  reducers: {
    updatePingInfo: (
      state,
      action: PayloadAction<{ lastPingTime: number; pingLatency: number }>
    ) => {
      state.lastPingTime = action.payload.lastPingTime
      state.pingLatency = action.payload.pingLatency
      state.isPingTimedOut = false
    },
    setPingTimeout: (state) => {
      state.isPingTimedOut = true
    }
  }
})

export const { updatePingInfo, setPingTimeout } = socketHealthSlice.actions
export default socketHealthSlice.reducer
